<div class="header" xmlns="http://www.w3.org/1999/html">
  <h1>
    {{ supplier.name }} Returns
    <img [src]="supplier.config?.logo" *ngIf="supplier.config?.logo" [alt]="supplier.name" />
  </h1>
  <p>Complete your details to get your return parcel on the go.</p>
</div>

<div class="container">
  <div class="return-details">
    <h3>Return Details <i class="search-icon"></i></h3>

    <form [formGroup]="returnDetailsForm" autocomplete="off">
      <div class="form-group">
        <input
          class="order-number-input"
          type="text"
          formControlName="orderNumber"
          required
          placeholder=" "
          [class.invalid]="returnDetailsValidation.orderNumber"
        />
        <label>{{ supplier?.config?.referencePlaceholder }}</label>
        <span
          class="tooltip tooltip--top"
          data-tooltip="Your original order number provided by the store you purchased from"
        ></span>
      </div>
      <div class="form-group">
        <select
          formControlName="reasonForReturn"
          required
          placeholder=" "
          [class.dirty]="returnDetailsValidation.reasonForReturn"
        >
          <!-- Though the formControl is not associated with any option value, semantically (and for Safari)
               there needs to be an element (option) to be "selected". Removing this makes some webkit-based browsers
               jump to the first option even if the select is valued for it. -->
          <option disabled selected value></option>
          <option *ngFor="let reason of supplier.config?.returnReasonOptions" [ngValue]="reason">
            {{ reason }}
          </option>
        </select>
        <label>{{ supplier?.config?.returnReasonPlaceholder }}</label>
      </div>
      <div class="form-group">
        <textarea
          formControlName="additionalDetails"
          rows="2"
          placeholder=" "
          [class.invalid]="returnDetailsValidation.additionalDetails"
          (input)="updateCharacterCount()"
          [maxlength]="maxCharacters"
        ></textarea>
        <label>Additional details</label>
        <div class="character-limit">{{ characterCount }}/{{ maxCharacters }}</div>
      </div>
    </form>
    <div class="pargo-point" *ngIf="pickupPoint?.point">
      <h3>Pargo Point</h3>
      <div class="pargo-point-container">
        <h5>{{ pickupPoint.point?.storeName }}</h5>
        <address>
          <div class="left">
            <i class="pup-location"></i>
          </div>
          <div class="right">
            <span>
              {{ pickupPoint.point?.address1 }}{{ pickupPoint.point?.address2 ? ", " : "" }}
              {{ pickupPoint.point?.address2 }}{{ pickupPoint.point?.suburb ? ", " : "" }}
              {{ pickupPoint.point?.suburb }}{{ pickupPoint.point?.city ? ", " : "" }}
              {{ pickupPoint.point?.city }}{{ pickupPoint.point?.postalcode ? ", " : "" }}
              {{ pickupPoint.point?.postalcode }}
            </span>
          </div>
        </address>
        <button routerLink="/pup-selection">Reselect</button>
      </div>
    </div>
  </div>
  <div class="your-details">
    <h3>Your Details</h3>

    <form [formGroup]="yourDetailsForm" autocomplete="off">
      <div class="form-group">
        <input
          type="text"
          formControlName="firstName"
          required
          placeholder=" "
          [class.invalid]="yourDetailsValidation.firstName"
        />
        <label>First name</label>
      </div>
      <div class="form-group">
        <input
          type="text"
          formControlName="surname"
          required
          placeholder=" "
          [class.invalid]="yourDetailsValidation.surname"
        />
        <label>Surname</label>
      </div>
      <div class="form-group">
        <input
          type="email"
          formControlName="emailAddress"
          required
          placeholder=" "
          [class.invalid]="yourDetailsValidation.emailAddress"
        />
        <label>Email address</label>
      </div>
      <div class="form-group">
        <input
          type="tel"
          formControlName="mobileNumber"
          placeholder=" "
          [class.invalid]="yourDetailsValidation.mobileNumber"
        />
        <label>Mobile number</label>
      </div>
    </form>
    <p
      class="disclaimer"
      *ngIf="supplier.config?.returnPolicy && !supplier.config?.termsAndConditions"
    >
      By continuing, you agree to the respective brand's
      <a [href]="supplier.config?.returnPolicy" target="_blank">return policy</a>.
    </p>
    <p
      class="disclaimer"
      *ngIf="!supplier.config?.returnPolicy && supplier.config?.termsAndConditions"
    >
      By continuing, you agree to the respective brand's
      <a [href]="supplier.config?.termsAndConditions" target="_blank">terms and conditions</a>.
    </p>
    <p
      class="disclaimer"
      *ngIf="supplier.config?.returnPolicy && supplier.config?.termsAndConditions"
    >
      By continuing, you agree to the respective brand's
      <a [href]="supplier.config?.returnPolicy" target="_blank">return policy</a>
      and associated
      <a [href]="supplier.config?.termsAndConditions" target="_blank">terms and conditions</a>.
    </p>
  </div>
</div>
<footer>
  <button class="back-btn" (click)="goBack.emit(pickupPoint.flow)">Back</button>
  <button class="confirm-btn" (click)="handleConfirm.emit()">Continue</button>
</footer>
